import Faq from '../faq';
import Tabs from '../tabs';

function ModuleFaq(container) {
	this.container = container;
	this.faqs = [];
	this.tabs = null;

	this.setupTabs = this.setupTabs.bind(this);

	if (this.isGroupedFaqs()) {
		window.addEventListener('load', this.setupTabs);
	}

	let faqContainers = this.container.getElementsByClassName('faq-container');

	faqContainers = [].slice.call(faqContainers);

	faqContainers.forEach(container => {
		const questionElements = container.getElementsByClassName('faq-question');
		const answerElements = container.getElementsByClassName('faq-answer');

		const faq = new Faq(questionElements, answerElements);
		if (this.isGroupedFaqs()) {
			faq.eventDispatcher.addEventListener('question-opened', function(){
				this.tabs.onResize();
			}.bind(this));

			faq.eventDispatcher.addEventListener('question-closed', function(){
				this.tabs.onResize();
			}.bind(this));
		}
		this.faqs.push(faq);
	});
}

ModuleFaq.prototype.isGroupedFaqs = function() {
	return this.container.querySelector('.faq-group-container') ? true : false;
};

ModuleFaq.prototype.onResize = function() {
	this.faqs.forEach(faq => {
		faq.onResize();
	});

	if (this.tabs) {
		this.tabs.onResize();
	}
};

ModuleFaq.prototype.setupTabs = function() {
	const navContainer = this.container.querySelector('.faqs-filters-container');
	//const contentContainer = container.querySelector('.contact-faqs-container');
	//const navContainer = this.container.querySelector('.faq-group-nav-buttons-container');
	const contentContainer = this.container.querySelector('.faq-group-container');
	this.tabs = new Tabs(navContainer, contentContainer);
};

export default ModuleFaq;